import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    NgbButtonsModule,
    NgbDatepickerModule,
    NgbModalModule,
} from '@cmps/ng-bootstrap';
import { SelectModule } from '@cmps/ng-select';
import { CmpsButtonModule, CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';

import { ExperimentalNgGridModule } from './experimental.grid';
import { ExperimentalPopUpModule } from './experimental.pop-up';
import { UserModalSelectComponent } from './modal-select.user.component';
import { PeopleOfInterestUserService } from './people-of-interest.user.service';
import { ProfileUserService } from './profile.user.service';
import { SearchUserOldComponent } from './search-user-old.component';
import { SearchUserComponent } from './search-user.component';
import { SearchUserContainerComponent } from './search-user.container.component';
import { SearchUserDialog } from './search-user.dialog';
import { UserSearchComponent } from './search.user.component';
import { TranslationIdMap } from './user.i18n';
import { UserService } from './user.service';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NgbButtonsModule,
        NgbDatepickerModule,
        NgbModalModule,
        SelectModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        ExperimentalNgGridModule,
        ExperimentalPopUpModule,
        CmpsButtonModule,
        CmpsIconModule,
    ],
    declarations: [
        UserSearchComponent,
        UserModalSelectComponent,
        SearchUserOldComponent,
        SearchUserComponent,
        SearchUserContainerComponent,
    ],
    exports: [
        UserSearchComponent,
        UserModalSelectComponent,
        SearchUserOldComponent,
        SearchUserComponent,
        SearchUserContainerComponent,
    ],
})
export class CmpsUserModule {
    static forRoot(): ModuleWithProviders<CmpsUserModule> {
        return {
            ngModule: CmpsUserModule,
            providers: [
                UserService,
                ProfileUserService,
                PeopleOfInterestUserService,
                SearchUserDialog,
            ],
        };
    }
}
